import Vue from 'vue';

const getDefaultState = () => {
	return {
		subscriptionName: '',
		subscriptionId: 0,
		upgradeable: false,
		cancellable: false,
		subscriptionExpirationDate: false,
		hasLegacyContracts: false,
		hasAgentFeature: false,
		preSelectPlanId: false
	}
}

const state = getDefaultState()

const getters = {
	getSubscriptionName: (state) => state.subscriptionName,
	getSubscriptionId: (state) => state.subscriptionId,
	subscriptionIsUpgradeable: (state) => state.upgradeable,
	subscriptionIsCancellale: (state) => state.cancellable,
	subscriptionIsCancelled: (state) => (state.subscriptionExpirationDate),
	subscriptionExpirationDate: state => state.subscriptionExpirationDate,
	getSubscriptionStatus: (state) => {
		if (state.subscriptionExpirationDate) {
			return Vue.$t('subscription-status.expires-on.label') + ' ' + state.subscriptionExpirationDate;
		} else {
			return 'subscription-status.active.label';
		}
	},
	subscriptionHasLegacyContracts: (state) => state.hasLegacyContracts,
	subscriptionHasAgentFeature: (state) => state.hasAgentFeature,
	subscriptionIsUnlimited: (state) => {
		return state.hasLegacyContracts;
	},
	getPreselectedPlanId: (state) => state.preSelectPlanId
}

const mutations = {
	resetSubscriptionState: (state) => Object.assign(state, getDefaultState()),
	setSubscription: (state, subscription) => {
		if (!subscription) {
			state.subscriptionName = 'Loading ...';
			state.subscriptionId = 0;
			state.upgradeable = false;
			state.cancellable = false;
			state.subscriptionExpirationDate = false;
			state.hasLegacyContracts = false;
			state.hasAgentFeature = false;
		} else {
			state.subscriptionName = subscription.subscriptionName;
			state.upgradeable = subscription.upgradeable;
			state.cancellable = subscription.cancellable;
			state.subscriptionExpirationDate = subscription.unsubscribedExpirationDate;
			state.hasLegacyContracts = subscription.has_legacy_contracts;
			state.hasAgentFeature = subscription.has_broker_feature;
			state.subscriptionId = subscription.subscription_id;
		}
	},
	setPreselectedPlanId: (state, id) => state.preSelectPlanId = id
}

const actions = {
	fetchUserSubscription({getters, commit, dispatch}) {
		dispatch('setSubscriptionAsLoading');
		axios({
			method: 'GET',
			url: window.config.apiUrl + 'api/user/subscription',
			cancelToken: window.AuthorizationCancelSource.token
		}).then(response => {
			commit('setSubscription', response.data);
		});
	},
	setSubscriptionAsLoading({commit}) {
		commit('setSubscription', false);
	}
}

export default {
	state,
	getters,
	mutations,
	actions
}
